export const SOCIAL_BASE_URLS = {
  instagram: "https://www.instagram.com/",
  facebook: "https://www.facebook.com/",
  x: "https://x.com/",
  tiktok: "https://www.tiktok.com/@",
  paypal: "https://www.paypal.me/",
  skype: "skype:",
  snapchat: "https://www.snapchat.com/add/",
  spotify: "https://open.spotify.com/user/",
  twitch: "https://www.twitch.tv/",
  youtube: "https://www.youtube.com/@",
  telegram: "https://t.me/",
  pinterest: "https://www.pinterest.com/",
  tinder: "https://tinder.com/@",
  whatsapp: "https://wa.me/",
  discord: "https://discord.com/",
  linkedin: "https://www.linkedin.com/in/",
  amazon: "https://www.amazon.com/",
  email: "mailto:",
  web: "https://",
  threads: "https://www.threads.net/@",
  kwai: "https://www.kwai.com/@",
  reddit: "https://www.reddit.com/user/",
};

export const SOCIAL_COLORS = [
  { social: "instagram", hex: "#E1306C" },
  { social: "facebook", hex: "#1877F2" },
  { social: "x", hex: "#000000" },
  { social: "tiktok", hex: "#69C9D0" },
  { social: "paypal", hex: "#003087" },
  { social: "skype", hex: "#00AFF0" },
  { social: "snapchat", hex: "#FFFC00" },
  { social: "spotify", hex: "#1DB954" },
  { social: "twitch", hex: "#9146FF" },
  { social: "youtube", hex: "#FF0000" },
  { social: "telegram", hex: "#0088CC" },
  { social: "pinterest", hex: "#BD081C" },
  { social: "tinder", hex: "#FE3C72" },
  { social: "whatsapp", hex: "#25D366" },
  { social: "discord", hex: "#5865F2" },
  { social: "linkedin", hex: "#0077B5" },
  { social: "amazon", hex: "#FF9900" },
  { social: "email", hex: "#D14836" },
  { social: "web", hex: "#808080" },
  { social: "x", hex: "#000000" },
];
